<template>
    <div>
        <textarea class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-xs placeholder-gray-400 focus:outline-hidden focus:ring-gray-600 focus:border-gray-600 sm:text-sm" ref="wysiwyg" :id="id"></textarea>
        <input hidden class="hidden" :name="name" :value="clean">
    </div>
</template>

<script>
import debounce from 'debounce';
import suneditor from 'suneditor';
import plugins from 'suneditor/src/plugins';

export default {
    name: "wysiwyg",
    props: {
        name: String,
        id: String,
        value: String,
        sync: {
            type: Boolean,
            default: false,
        },
        encoded: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            clean: '',
            editor: null,
        };
    },
    mounted() {
        if (this.value) {
            this.clean = this.encoded ? this.b64DecodeUnicode(this.value) : this.value;

            if (this.clean === 'null') {
                this.clean = '';
            }
        }

        this.setup();

        window.addEventListener('resize', debounce(() => {
            this.editor.destroy();
            this.setup();
        }, 300));
    },
    methods: {
        b64DecodeUnicode(str) {
            // https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
            // Going backwards: from bytestream, to percent-encoding, to original string.
            return decodeURIComponent(atob(str).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        },

        setup() {
            this.editor = suneditor.create(this.$refs.wysiwyg, {
                height: 250,
                plugins: plugins,
                buttonList: [
                    [
                        'paragraphStyle',
                        'undo',
                        'redo',
                        'bold',
                        'link',
                        'list',
                        'underline',
                        'italic',
                        'fontColor',
                        'formatBlock',
                        'fontSize',
                        'textStyle',
                        'lineHeight',
                        'outdent',
                        'indent',
                        'codeView'
                    ],
                ],
            });

            if (this.clean) {
                this.editor.setContents(this.clean);
            }

            this.editor.onChange = (c) => {
                if (this.failsCleanCheck(c)) {
                    this.clean = '';
                    return;
                }

                this.clean = c;

                if (this.sync) {
                    this.$emit('input', this.clean);
                }
            };
        },

        failsCleanCheck(c) {
            if (c === '<p></p>') {
                return true;
            }

            if (c === '<p><br></p>') {
                return true;
            }

            return false;
        },
    }
}
</script>

<style>
    @import 'suneditor/dist/css/suneditor.min.css';
</style>
